
import { takeEvery, call, put } from "redux-saga/effects";
import { GET_DETAILDATA, SET_DETAILDATA } from "../actions";
import api from "../utils/axios";
export const watchGetDetailData = function* () {
  yield takeEvery(GET_DETAILDATA, workerGetDetailData);
};

function* workerGetDetailData(reqData) {
  try {
    const { url, params } = reqData.datas;
    const uri = `${url}?${params || ""}`;

    // Use your axios instance (api)
    const result = yield call(api.get, uri);
    
    // Process and store result
    yield put({ type: SET_DETAILDATA, value: [result.data] });
  } catch (e) {
    console.error("API error:", e);
    const returnError = e?.response?.data || [];
    yield put({ type: SET_DETAILDATA, value: [returnError] });
  }
}
